import {Component, Input} from "@angular/core";

@Component({
  selector: "admin-panel-confirm",
  templateUrl: "./confirm.component.html",
  styleUrls: ["./confirm.component.css"]
})
export class AdminPanelConfirmComponent {

  @Input() title: string = "";
  @Input() border: string = "";
  @Input() customs: string = "";

}
